import type { CreateTransitionFunctionPayload } from '@polyai/stream/commands/handlers/flow/create-transition-function/schema';

import { useAddStepFunction } from 'components/molecules/LexicalEditor/features/action/components/FlowTransition';
import type { TransitionModalFormValues } from 'components/molecules/Transitions/TransitionModalForm';
import TransitionModalForm from 'components/molecules/Transitions/TransitionModalForm';

interface ExitFlowPopupProps {
  onCreate?: (
    flow: CreateTransitionFunctionPayload['transitionFunction'],
  ) => void;
  onCancel?: (reason?: string) => void;
}

const ExitFlowPopup = ({ onCancel, onCreate }: ExitFlowPopupProps) => {
  const { addExitFlow } = useAddStepFunction(onCreate);

  const handleAddExitFlow = (data: TransitionModalFormValues) => {
    addExitFlow(data.transitionName);
  };

  return (
    <TransitionModalForm
      input={{
        label: 'Name',
        placeholder: 'for example “exit_from_step”',
      }}
      open
      onClose={() => onCancel?.()}
      onSubmit={handleAddExitFlow}
    />
  );
};

export default ExitFlowPopup;
